module.exports = __webpack_public_path__ + "static/media/Germany.b438c264.png";